export const Form = 'w-full md:w-max lg:grid grid-cols-[repeat(2,1fr)] gap-[27px_40px] flex flex-col';